export default {"src":"/_next/static/media/crossWithPawOutline50_40.871fd2ff.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};